module.exports = __webpack_public_path__ + "static/media/image (18).29cadb5f.jpg";